import {useAuth} from "../../shared/auth/AuthContext";
import {environment} from "../../config/environment";
import {getToken, getUserTypeFromToken} from "../../shared/utils/session";
import {ehEquipeBusifarm} from "./usersUtils";

/**
 * Se o token é da equipe Busifarm (ADMIN ou SUPPORT), pelo `userType`. Sem login (modo de
 * desenvolvimento sem autenticação), vale como equipe, como no resto da tela.
 */
export const sessaoDaEquipeBusifarm = (token) => (
    environment.disableAuth || ehEquipeBusifarm(getUserTypeFromToken(token))
);

/** Se quem está logado é da equipe Busifarm: só ela vê o que é só da Busifarm (ex.: portal, BBF-179). */
export const useEquipeBusifarm = () => {
    const {userLogged} = useAuth() || {};
    return sessaoDaEquipeBusifarm(getToken(userLogged));
};
